<template>
  <Analitica />
</template>

<script>
import Analitica from '../components/Analitica';

export default {
  components: {
    Analitica,
  },
};
</script>
